import React from 'react';
import 'materialize-css';
import {Navbar, NavItem, Icon, Row, Col} from 'react-materialize';
import {Link, NavLink, Redirect} from "react-router-dom";
import VkAuth from "react-vk-auth";
import AuthFromVK from "./components/AuthFromVK";


class Login extends React.Component{
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div className={'container'}>
                <Row>
                    <Col s={12} m={10} offset={'m1'}>
                        {!this.props.auth ?
                            <div>
                                <h5>Войти через VK:</h5>
                                <AuthFromVK callback={this.props.callback}/>
                            </div> : <Redirect to={'/myAccount/'} /> }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Login;
